<article>
  <opac-skeleton class="fake-cover"></opac-skeleton>
  <section>
    <opac-skeleton class="fake-title"></opac-skeleton>
    <opac-skeleton class="fake-author"></opac-skeleton>
    <opac-skeleton
      class="hide-tablet"
      style="width: 95px; height: 12px; margin-top: 38px; --border-radius: 4px"></opac-skeleton>
  </section>
</article>
